@if (!params.canRemoveLabels && params.isAddMode) {
  <div style='pointer-events: visible; margin: 40px;'>
    <div style='margin-bottom: 10px !important;'>No labels created. Create custom portfolio<br/>labels in iRebal settings.</div>
    <a (click)='openGlobalSettings()'>Go to Settings</a>
  </div>
}

@if (!params.canRemoveLabels && !params.isAddMode) {
  <div style='pointer-events: visible; margin: 40px;'>
    <div style='margin-bottom: 10px !important;'>No labels to be removed.</div>
  </div>
}